import React from "react";
import styled from "styled-components";

const TimelineContainer = styled.div`
  width: 100%;
  max-width: 800px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const VerticalLine = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 200px;
  width: 1.7px;
  border-left: 1.7px dashed #000;

  @media screen and (max-width: 991px) {
    left: 37px;
  }

  @media print {
    left: 175px;
  }
`;

const Timeline = ({ children }) => {
  return (
    <TimelineContainer>
      <VerticalLine />
      {children}
    </TimelineContainer>
  );
};

export default Timeline;
